import { timeDifference, dateToString } from '.';
export const timeDifferenceWithLocale = ({ timeStamp, locale = 'en', justNowText = 'Just Now', invalidDateText = 'Invalid Date', }) => {
    const current = new Date().getTime();
    const msPerMinute = 60 * 1000;
    const msPerHour = msPerMinute * 60;
    const msPerDay = msPerHour * 24;
    const msPerMonth = msPerDay * 30;
    const elapsed = current - new Date(timeStamp).getTime();
    try {
        const rtf = new Intl.RelativeTimeFormat(locale, {
            style: 'long',
        });
        if (isNaN(elapsed)) {
            return `${invalidDateText}`;
        } // no key yet
        let calcTime;
        if (elapsed < msPerMinute) {
            if (justNowText) {
                return `${justNowText}`;
            }
            calcTime = Math.round(elapsed / 1000);
            return rtf.format(-calcTime, 'second');
        }
        else if (elapsed < msPerHour) {
            calcTime = Math.round(elapsed / msPerMinute);
            return rtf.format(-calcTime, 'minute');
        }
        else if (elapsed < msPerDay) {
            calcTime = Math.round(elapsed / msPerHour);
            return rtf.format(-calcTime, 'hour');
        }
        else if (elapsed < msPerMonth) {
            calcTime = Math.round(elapsed / msPerDay);
            if (calcTime < 8) {
                return rtf.format(-calcTime, 'day');
            }
            else {
                return dateToStringWithLocale(timeStamp, locale);
            }
        }
        else {
            return dateToStringWithLocale(timeStamp, locale);
        }
    }
    catch (e) {
        return timeDifference(timeStamp);
    }
};
export const dateToStringWithLocale = (timeStamp, locale = 'en') => {
    try {
        const dateFormatter = new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
        return dateFormatter.format(new Date(timeStamp));
    }
    catch (e) {
        return dateToString(timeStamp);
    }
};
//# sourceMappingURL=timeSinceWithLocale.js.map